import { Component } from '@angular/core';
import { SeoService } from 'src/app/seo.service';
@Component({
    selector: 'app-page404',
    templateUrl: './page404.component.html',
    styleUrls: ['./page404.component.scss'],
    standalone: false
})
export class Page404Component {
  constructor(private seo: SeoService) {
    //constructor
    this.seo.setTags({
      title: 'SmartAccuPay page 404', // Title
      titleSuffix: '- SmartAccuPay', // Title Suffix
      description: 'SmartAccuPay Invoice Management', // Description
      image: '', // Image
      keywords: 'SmartAccuPay' // Keywords
    });
  }
}
